export default "__VITE_ASSET__2ORO4ns0__"